import React from 'react';
export function Footer() {
  return <footer className="w-full bg-mint-dark px-6 py-10 text-center text-white" data-id="element-74" data-mp="32wmqrybuniwl">
      <p className="text-xs text-white/70" data-id="element-75" data-mp="3gg10u7y865zr">© 2024 Dra. Marta González | Todos los derechos reservados</p>
      <nav className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs" data-id="element-76" data-mp="32p5kybpb6omo">
        <a href="#" className="transition-colors duration-150 ease-out hover:text-amber" data-id="element-77" data-mp="36q953aee36tp">
          Política de Privacidad
        </a>
        <span aria-hidden="true" className="text-white/40" data-id="element-78" data-mp="3ud7g3sjqpmk8">
          |
        </span>
        <a href="#" className="transition-colors duration-150 ease-out hover:text-amber" data-id="element-79" data-mp="37xv6falryhh">
          Términos de Servicio
        </a>
        <span aria-hidden="true" className="text-white/40" data-id="element-80" data-mp="3qd6qdbr6xoxv">
          |
        </span>
        <a href="mailto:manualeslistos@gmail.com" className="transition-colors duration-150 ease-out hover:text-amber" data-id="element-81" data-mp="29z6tyark0hfd">
          manualeslistos@gmail.com
        </a>
      </nav>
      <p className="mt-4 text-xs text-white/80" data-id="element-82" data-mp="2ew700loelk6h">Diseñado para cambiarte la vida 💚</p>
    </footer>;
}